<template>
  <dv-digital-flop :config="config" style="width: 100%; height: 50px" />
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
};
</script>

<style lang="less" scoped>
</style>